// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb[data-v-7a315fb5]{background:#fff;padding:0;margin-bottom:20px;text-align:left}.breadcrumb-item[data-v-7a315fb5]{display:inline-flex;align-items:center;cursor:pointer;margin-right:5px}.breadcrumb-item[data-v-7a315fb5]:first-of-type{border-left:3px solid #417ff9;padding-left:7px}.breadcrumb-item[data-v-7a315fb5]:not(:first-of-type):before{content:\">\";height:20px;vertical-align:middle;padding:0 5px;color:#ccc}", ""]);
// Exports
module.exports = exports;
